import React, { Component } from "react";
import { Dialog } from "material-ui";
import Checkbox from "material-ui/Checkbox";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import FlatButton from "material-ui/FlatButton";
import Clear from "material-ui/svg-icons/content/clear";
import { isEmpty } from "lodash";

// css
import "./segmentlist.css";

const styles = {
  iconStyle: {
    fill: "#000000",
    transform: "scale(0.8)",
    WebkitTransform: "scale(0.8)",
    MsTransform: "scale(0.8)",
    MozTransform: "scale(0.8)",
    marginRight: "0",
  },
  radioButton: {
    width: "15px",
    fill: "#000000",
  },
  labelStyle: {
    fontSize: "13px",
    marginBottom: 0,
    fontWeight: "bold",
  },
};

class CreateCampaign extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.arr = new Set([]); // for hashType record
    this.state = {
      ifCreateButtonEnable: false,
      ifCaseNumberEnable: false,
      ifShowButtonTip: false,
      createCampaignData: {
        clientId: "",
        caseNumber: "",
        emailChannelEnabled: false,
        socialChannelEnabled: false,
        displayChannelEnabled: false,
        directMailChannelEnabled: false,
        segmentId: "",
      },
    };
  }
  closeDialog() {
    this.props.closeCreateCampaignDialog();
    // rollback
    this.props.rollbackRequestSuccessToFalse(false);
    this.throttle = true; // set throttle to true, which button can be clicked.
    this.arr = new Set([]);
    this.setState({
      ifCreateButtonEnable: false,
      ifShowButtonTip: false,
      createCampaignData: {
        clientId: "",
        caseNumber: "",
        emailChannelEnabled: false,
        socialChannelEnabled: false,
        displayChannelEnabled: false,
        directMailChannelEnabled: false,
        segmentId: "",
      },
    });
  }
  handleDirectMail(e, isInputChecked) {
    this.setState({
      createCampaignData: {
        ...this.state.createCampaignData,
        directMailChannelEnabled: isInputChecked,
      }
    }, () => {
      this.setState({
        ifCreateButtonEnable: this.ifButtonEnable(),
      });
    },)
  }
  handleEmailChecked(e, isInputChecked) {
    if (!isInputChecked) {
      this.setState(
        {
          createCampaignData: {
            ...this.state.createCampaignData,
            emailChannelEnabled: isInputChecked,
          },
        },
        () => {
          this.setState({
            ifCreateButtonEnable: this.ifButtonEnable(),
          });
        },
      );
    } else {
      this.setState(
        {
          createCampaignData: {
            ...this.state.createCampaignData,
            emailChannelEnabled: isInputChecked,
          },
        },
        () => {
          this.setState({
            ifCreateButtonEnable: this.ifButtonEnable(),
          });
        },
      );
    }

    this.props.handleEmailChecked(e, isInputChecked);
  }
  handleSocialMedia(e, isInputChecked) {
    e.stopPropagation();
    if (!isInputChecked) {
      this.setState(
        {
          createCampaignData: {
            ...this.state.createCampaignData,
            socialChannelEnabled: isInputChecked,
          },
        },
        () => {
          this.setState({
            ifCreateButtonEnable: this.ifButtonEnable(),
          });
        },
      );
    } else {
      this.setState({
        createCampaignData: {
          ...this.state.createCampaignData,
          socialChannelEnabled: isInputChecked,
        },
      }, () => {
        this.setState({
          ifCreateButtonEnable: this.ifButtonEnable(),
        })
      });
    }

    this.props.handleSocialMedia(e, isInputChecked);
  }
  handleDisplayCheck(e, isInputChecked) {
    this.setState(
      {
        createCampaignData: {
          ...this.state.createCampaignData,
          displayChannelEnabled: isInputChecked,
        },
      },
      () => {
        this.setState({
          ifCreateButtonEnable: this.ifButtonEnable(),
        });
      },
    );

    this.props.handleDisplayCheck(e, isInputChecked);
  }
  handleOrderNumberKeyUp() {
    if (
      !isEmpty(this.refs.orderNumber.value) &&
      /^\d{8}$/g.test(this.refs.orderNumber.value)
    ) {
      this.setState({
        ...this.state,
        ifCaseNumberEnable: true,
      }, () => {
        this.setState({
          ifCreateButtonEnable: this.ifButtonEnable(),
        });
      })

    } else {
      this.setState({
        ifCreateButtonEnable: false,
      });
    }
  }

  // call api
  createCampaign() {
    if (this.throttle) {
      this.throttle = false;
      this.setState(
        {
          createCampaignData: {
            ...this.state.createCampaignData,
            clientId: this.props.createCampaign_clientId,
            segmentId: this.props.createCampaign_segment_id,
            caseNumber: this.refs.orderNumber.value,
          },
        },
        () => {
          this.props.getCreateCampaign(
            this.props.createCampaign_segment_id,
            this.state.createCampaignData,
          );
        },
      );
      window.setTimeout(() => {
        this.throttle = true;
      }, 500);
    }
  }
  ifButtonEnable() {
    const {
      emailChannelEnabled,
      displayChannelEnabled,
      socialChannelEnabled,
      directMailChannelEnabled
    } = this.state.createCampaignData;
    if (
      !isEmpty(this.refs.orderNumber.value) &&
      /^\d{8}$/g.test(this.refs.orderNumber.value)
    ) {
      if (
          (emailChannelEnabled ||
        displayChannelEnabled || socialChannelEnabled || directMailChannelEnabled) && this.state.ifCaseNumberEnable
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  render() {
    return (
      <div className="create-campaign-wrapper">
        <Dialog
          open={this.props.openCreateCampaignDialog}
          modal={false}
          autoScrollBodyContent={true}
          autoDetectWindowHeight={true}
          repositionOnUpdate={false}
          contentStyle={{ width: "60%", minWidth: "600px" }}
          bodyStyle={{ padding: "20px" }}
        >
          <div
            className="create-campaign-outer"
            style={{
              display:
                this.props.create_campaign &&
                this.props.create_campaign.ifRequestSuccess
                  ? "none"
                  : "block",
            }}
          >
            <h2 className="create-campaign-h2">CREATE AN AUDIENCE FILE</h2>
            <h3 className="create-campaign-h3">Select a Campaign Type:</h3>
            <div className="create-campaign-wrapper">
              {/*<div className="row1">*/}
              {/*<span onClick={() => this.handleSelectAllCheckbox()}>All</span>*/}
              {/*</div>*/}
              <div className="selection">
                <div className="email">
                  <Checkbox
                      label="Direct Mail"
                      onCheck={(e, isInputChecked) =>
                          this.handleDirectMail(e, isInputChecked)
                      }
                      iconStyle={styles.iconStyle}
                      labelStyle={styles.labelStyle}
                  />
                </div>
                <div className="social">
                  <div className="main">
                    <Checkbox
                        label="Social"
                        onCheck={(e, isInputChecked) =>
                            this.handleSocialMedia(e, isInputChecked)
                        }
                        checked={this.props.ifSocialMediaChecked}
                        iconStyle={styles.iconStyle}
                        labelStyle={styles.labelStyle}
                    />
                  </div>
                </div>
                <div className="display">
                  <div className="main">
                    <Checkbox
                        label="Display"
                        onCheck={(e, isInputChecked) =>
                            this.handleDisplayCheck(e, isInputChecked)
                        }
                        checked={this.props.ifDisplayChecked}
                        iconStyle={styles.iconStyle}
                        labelStyle={styles.labelStyle}
                    />
                  </div>
                </div>
                <div className="email">
                  <div className="main">
                    <Checkbox
                        label="Email"
                        onCheck={(e, isInputChecked) =>
                            this.handleEmailChecked(e, isInputChecked)
                        }
                        iconStyle={styles.iconStyle}
                        labelStyle={styles.labelStyle}
                    />
                  </div>
                </div>
              </div>
              <div className="common-input">
                <label htmlFor=""><span style={{color: 'red'}}>*</span>Enter Case Number</label>
                <input
                    type="text"
                    ref="orderNumber"
                    onKeyUp={() => this.handleOrderNumberKeyUp()}
                />
              </div>
              <div
                  className="clearfix"
                  style={{
                    display:
                        this.props.create_campaign &&
                        isEmpty(this.props.create_campaign.error_payload)
                            ? "none"
                            : "block",
                  }}
              >
                <p style={{color: "red", fontSize: "12px", marginTop: "1em"}}>
                  {this.props.create_campaign &&
                      this.props.create_campaign.error_payload}
                </p>
              </div>
              <div className="btns clearfix">
                {/*tips*/}
                <section
                    style={{
                      display: this.state.ifShowButtonTip ? "block" : "none",
                    }}
                >
                  You must choose at least one checkbox to continue.
                </section>
                {/*the end*/}
                <button
                    type="button"
                    className="btn btn-default btn-aa-default pull-right"
                    onClick={e => {
                      this.createCampaign();
                    }}
                    disabled={!this.state.ifCreateButtonEnable}
                >
                  CREATE AUDIENCE FILE
                </button>
                <button
                    type="button"
                    className="pull-right btn btn-aa-info mr-20"
                    onClick={e => {
                      this.closeDialog();
                    }}
                >
                  CANCEL
                </button>
              </div>
            </div>

            <Clear
                style={{
                  position: "absolute",
                  right: "0em",
                  cursor: "pointer",
                  top: "-0.5em",
                }}
                onClick={() => this.closeDialog()}
            />
          </div>
          {/*request successly*/}
          <section
              style={{
                padding: "2em 6em",
                position: "relative",
                display:
                    this.props.create_campaign &&
                    this.props.create_campaign.ifRequestSuccess
                        ? "block"
                        : "none",
              }}
          >
            <p
                style={{
                  fontWeight: "bolder",
                  color: "black",
                  fontSize: "18px",
                  display:
                      this.props.create_campaign && this.props.create_campaign.error
                          ? "none"
                          : "block",
                }}
            >
              We are now preparing your audience file. <br/>
              You will soon receive an email when it's ready.
            </p>
            {/*error*/}
            <p
                style={{
                  fontWeight: "bolder",
                  color: "black",
                  fontSize: "18px",
                  display:
                      this.props.create_campaign && this.props.create_campaign.error
                          ? "block"
                          : "none",
                }}
            >
              {this.props.create_campaign &&
                  this.props.create_campaign.error_payload}
            </p>
            <div style={{textAlign: "center", marginTop: "2em"}}>
              <FlatButton
                  label="CANCEL"
                  style={{color: "black", border: "1px solid black"}}
                  backgroundColor="#FFFFFF"
                  hoverColor="#FFFFFF"
                  onClick={() => this.closeDialog()}
              />
            </div>
            <Clear
                style={{
                  position: "absolute",
                  right: "2em",
                  cursor: "pointer",
                  top: "-0.5em",
                }}
                onClick={() => this.closeDialog()}
            />
          </section>
          {/*the end*/}
        </Dialog>
      </div>
    );
  }
}

export default CreateCampaign;



// WEBPACK FOOTER //
// ./src/components/Segment/List/CreateCampaign.jsx